var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('ShelfLoading'):(_vm.isLoaded)?_c('ShelfLoaded'):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }